import { useState } from 'react';
import { CsmMenuItem, useCsmDropdown } from './useCsmDropdown';
import { csmHashById } from 'CsmModule/constants';

export const useCsmSelector = ({ accountId }: { accountId: Nullable<number> }) => {
  const [csm, setCsm] = useState(accountId ? csmHashById[accountId] : undefined);
  const { openCsmDropdown } = useCsmDropdown();

  const onCsmSelectorClick = ({
    target,
    onSelect,
  }: Pick<Parameters<typeof openCsmDropdown>[0], 'target'> & {
    onSelect?: ({ csm }: { csm: CsmMenuItem }) => void;
  }) => {
    openCsmDropdown({
      target,
      onSelect: ({ csm }) => {
        onSelect?.({ csm });
        setCsm(csm);
      },
    });
  };

  const clearCsm = () => {
    setCsm(undefined);
  };

  return {
    selectedCsm: csm,
    onCsmSelectorClick,
    setCsm,
    clearCsm,
  };
};
